var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('coozzy-page-title',{attrs:{"title":_vm.$t('message.navigation.settings.title')}}),_c('edit-password-settings')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }